import { render, staticRenderFns } from "./vue-html-pdf.vue?vue&type=template&id=6da35b8b"
import script from "./vue-html-pdf.vue?vue&type=script&lang=js"
export * from "./vue-html-pdf.vue?vue&type=script&lang=js"
import style0 from "./vue-html-pdf.vue?vue&type=style&index=0&id=6da35b8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports